/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";

let Bottom = () => {
    return (
        <>
            <div className="section" id="section3">
                <div className="demo_index">
                    <div className="demo_con">
                        <div className="pagesize">
                            <div className="db_set">
                                <div className="swiper-container">
                                    <div className="swiper-wrapper">
                                        <div className="swiper-slide">
                                            <Swiper
                                                spaceBetween={50}
                                                autoplay={{
                                                    "delay": 2500,
                                                    "disableOnInteraction": false
                                                }}
                                            >
                                                <SwiperSlide>
                                                    <div className="db_box"><div className="db_img">
                                                        <img src={require("../../image/img_demo_01.jpg").default} alt="img_demo_01" /></div>
                                                        <h3>「 i寶貝，打開電視 」</h3>
                                                    </div>
                                                </SwiperSlide>
                                                <SwiperSlide>
                                                    <div className="db_box">
                                                        <div className="db_img"><img src={require("../../image/img_demo_02.jpg").default} alt="img_demo_02" /></div>
                                                        <h3>「 i寶貝，關閉電視 」</h3>
                                                    </div>
                                                </SwiperSlide>
                                                <SwiperSlide>
                                                    <div className="db_box">
                                                        <div className="db_img"><img src={require("../../image/img_demo_03.jpg").default} alt="img_demo_03" /></div>
                                                        <h3>「 i寶貝，開啟燈 」</h3>
                                                    </div>
                                                </SwiperSlide>
                                                <SwiperSlide>
                                                    <div className="db_box">
                                                        <div className="db_img"><img src={require("../../image/img_demo_04.jpg").default} alt="img_demo_04" /></div>
                                                        <h3>「 i寶貝，開啟音樂(KKBox) 」</h3>
                                                    </div>
                                                </SwiperSlide>
                                            </Swiper>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="summary_index">
                    <div className="summary_con">
                        <div className="pagesize">
                            <div className="swiper-container">
                                <div className="swiper-wrapper">
                                    <div className="swiper-slide">
                                        <img src={require("../../image/img_summary_01.png").default} alt="img_summary_01" />
                                    </div>
                                </div>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section" id="section3">
                <div className="download_index">
                    <div className="download_con">
                        <div className="pagesize">
                            <div className="dc_box">
                                <div className="dc_tit"></div>
                            </div>
                            <div className="dc_box">
                                <div className="dc_qrcode">
                                    <div className="dc_img">
                                        <img src={require("../../image/img_qrcode_ios.png").default} alt="img_qrcode_ios" />
                                        <a className="ios" href="https://apps.apple.com/tw/app/i%E5%AF%B6%E8%B2%9D/id1457818636?l=en" target="_blank" rel="noreferrer"></a>
                                    </div>
                                    <div className="dc_img">
                                        <img src={require("../../image/img_qrcode_android.png").default} alt="img_qrcode_android" />
                                        <a className="android" href="https://play.google.com/store/apps/details?id=com.ibobbyplus" target="_blank" rel="noreferrer"></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Bottom;
